/**
 * A aprovação do pedido de Terraform no cartão da conversa (consoleai#25973).
 *
 * No PRD do BackOfficePOS o pedido ficou esperando aprovação e o único lugar
 * para decidir era o chamado: quem pediu não via quem decide, e quem decide não
 * via onde. Reusa `DecisaoDoPedido` (a mesma do chamado e da tela de WAF);
 * quem decide se o botão aparece segue sendo o servidor (`aprovacao.pode_aprovar`).
 * Só monta com `aprovacao`: fora de `aguardando_aprovacao` não há o que mostrar.
 */
import { useQueryClient } from '@tanstack/react-query'
import type { PedidoDoCartao } from '@/api/terraformRunner'
import { DecisaoDoPedido } from '@/components/chamados/DecisaoDoPedido'
import { CHAVE_PEDIDO_TERRAFORM } from '@/hooks/useTerraformChangeRequest'

function Decisao({ pedido }: { pedido: PedidoDoCartao }) {
  const qc = useQueryClient()
  return (
    <DecisaoDoPedido pedido={pedido}
                     onDecidido={() => void qc.invalidateQueries({
                       queryKey: [CHAVE_PEDIDO_TERRAFORM] })} />
  )
}

export function DecisaoNoCartao({ pedido }: { pedido: PedidoDoCartao }) {
  return pedido.aprovacao ? <Decisao pedido={pedido} /> : null
}
